import CryptoJS from 'crypto-js';

const SECRET_KEY: string = process.env.NEXT_PUBLIC_ENCRYPTION_KEY;

/**
 * Encrypt password and format as user_id
 * @param password - The password to encrypt
 * @returns Encrypted password with usr_ prefix
 */
export function encryptPassword(password: string): string {
  try {
    const encrypted = CryptoJS.AES.encrypt(password, SECRET_KEY).toString();
    // Replace special characters that might cause issues in metadata
    const safeEncrypted = encrypted.replace(/[+/=]/g, (match: string): string => {
      switch (match) {
        case '+':
          return '-';
        case '/':
          return '_';
        case '=':
          return '.';
        default:
          return match;
      }
    });
    return `usr_${safeEncrypted}`;
  } catch (error) {
    console.error('Encryption error:', error);
    throw new Error('Failed to encrypt password');
  }
}
